import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { AlertTriangle } from 'lucide-react';
import { navigationConstraints } from '../../lib/leiConditions';

const IMPACT_TONE = {
  High: 'bg-rose-100 text-rose-700 border-rose-200',
  Medium: 'bg-amber-100 text-amber-700 border-amber-200',
  Low: 'bg-slate-100 text-slate-600 border-slate-200',
};

/**
 * Missing Middle Friction → Navigation Constraints (Rec 7).
 * Ranks the weakest condition stages, explaining where conditions are
 * suppressing value creation. Same scores, ranked by where they bind.
 */
export function NavigationConstraintsPanel({ conditions }) {
  const constraints = navigationConstraints(conditions, 3);
  if (!constraints.length) return null;

  return (
    <Card data-testid="navigation-constraints-panel">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <AlertTriangle className="h-4 w-4 text-amber-600" />
          Navigation Constraints
        </CardTitle>
        <p className="text-xs text-slate-500">Where conditions are most suppressing value creation right now.</p>
      </CardHeader>
      <CardContent>
        <ol className="space-y-2">
          {constraints.map((c, i) => (
            <li
              key={c.key}
              className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2"
              data-testid={`constraint-${c.key}`}
            >
              <span className="flex items-center gap-2 min-w-0">
                <span className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-slate-900 text-[11px] font-bold text-white">
                  {i + 1}
                </span>
                <span className="min-w-0">
                  <span className="text-sm font-semibold text-slate-800 block truncate">{c.pillarShortName}</span>
                  <span className="text-[11px] text-slate-500">{c.label} conditions · {Math.round(c.score)}</span>
                </span>
              </span>
              <span className={`rounded-full border px-2.5 py-0.5 text-[11px] font-bold flex-shrink-0 ${IMPACT_TONE[c.impact]}`}>
                {c.impact} Impact
              </span>
            </li>
          ))}
        </ol>
      </CardContent>
    </Card>
  );
}
